import { useTranslation } from "react-i18next";
import emailSentIcon from "../../images/icons/alerts/emailSentIcon.svg";
import successIcon from "../../images/icons/alerts/successIcon.svg";
import { namespaces } from "../../i18n/i18n.constants";
import { useAppDispatch, useTypedSelector } from "../../app/store";
import { selectAlertContent, setAlertContent } from "../../pages/layoutes/authLayout/authSlice";
import { AuthAlertTypeEnum } from "../../app/enums/authAlertTypeEnum";
import { Button } from "react-bootstrap";
import { useCallback } from "react";
import { useNavigate } from "react-router";
import { routes } from "../../app/routes/routes";

const AuthAlert = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const alertContent = useTypedSelector(selectAlertContent);
    const navigate = useNavigate();

    const handleSignIn = useCallback(() => {
        dispatch(setAlertContent(null));
        navigate(routes.login.path);
    }, [dispatch, navigate]);

    const mapIconByType = (type: AuthAlertTypeEnum) => {
        switch (type) {
            case AuthAlertTypeEnum.emailSent:
                return emailSentIcon;
            case AuthAlertTypeEnum.confirmed:
                return successIcon;
            default:
                return "";
        }
    };
    return alertContent ? (
        <div className="auth-alert text-center my-3">
            <img className="mb-3" src={mapIconByType(alertContent.type)} alt={`${t("image.emailSent", { ns: namespaces.aria })}`} />
            <p className="fs-3 fw-bold">{alertContent.title}</p>
            {Array.isArray(alertContent.content) ? (
                alertContent.content.map((item, index) => (
                    <p key={index} className="mb-0">
                        {item}
                    </p>
                ))
            ) : (
                <p>{alertContent.content}</p>
            )}
            {alertContent.type === AuthAlertTypeEnum.confirmed ? (
                <Button variant="primary" onClick={handleSignIn} className="w-100 mt-4 p-3">
                    {t("login.signIn", {ns: namespaces.auth})}
                </Button>
            ) : undefined}
        </div>
    ) : undefined;
};

export default AuthAlert;
